import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActiveCartFacade, Cart, OrderEntry } from "@spartacus/cart/base/root";
import {
  filter,
  map,
  Observable,
  skip,
  Subscription,
  switchMap,
  take,
} from "rxjs";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
import { KN_BR_CUSTOMER_CURRENT } from "../../../../constants/api.endpoints.constant";
import { CustomerData } from "../../../models/customer.model";
import { KnBrCustomerContextService } from "../../../store/kn-br-customer-context/kn-br-customer-context.service";
import { KnBrCommonService } from "src/app/services/kn-br-common.service";
import { CwtSpinnerComponent } from "../../../common/cwt-spinner/cwt-spinner.component";
import { NgClass, AsyncPipe } from "@angular/common";

@Component({
    selector: "kn-br-cart-page-options",
    templateUrl: "./kn-br-cart-page-options.component.html",
    styleUrls: ["./kn-br-cart-page-options.component.scss"],
    imports: [
        CwtSpinnerComponent,
        NgClass,
        AsyncPipe,
    ],
})
export class KnBrCartPageOptionsComponent implements OnInit, OnDestroy {
  customerContextData$: Observable<CustomerData> =
    this.knBrCustomerContextService.get$;
  selectedCustomer: CustomerData;
  subscription: Subscription;
  customerNumber: string;
  selectedOption = 0;
  cart$: Observable<Cart>;
  cartId: any;
  deliveryModeOptions = [];
  entries$: Observable<OrderEntry[]>;
  reviewItems = "Review your items and proceed to checkout";
  emptyCart = "Your cart is currently empty";
  plantIdList: { name: string; code: string }[];

  constructor(
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrCheckoutService: KnBrCheckoutService,
    protected activeCartService: ActiveCartFacade,
    protected cdr: ChangeDetectorRef,
    protected commonService: KnBrCommonService
  ) {
    this.knBrCheckoutService.setCheckoutFlag(false);
    this.subscription = this.customerContextData$.subscribe((value) => {
      if (value) {
        this.selectedCustomer = value;
        this.customerNumber = value?.customerNumber
          ? value?.customerNumber
          : KN_BR_CUSTOMER_CURRENT;
      }
    });
  }

  ngOnInit(): void {
    this.cart$ = this.activeCartService.getActive();

    this.subscription.add(
      this.knBrCheckoutService.getPlantIdListData().subscribe((resp:any) => {
        const result = resp[0].split(";").filter(Boolean).map((s) => {
            const [name, code] = s.split(":");
            return { name, code };
          });
          this.plantIdList = result;
          
      }),
    );

    this.subscription.add(
      this.activeCartService
        .getActiveCartId()
        .pipe(
          filter((cartId) => !!cartId),
          switchMap((cartId) => {
            this.cartId = cartId;
            return this.knBrCheckoutService.getDeliveryModes(
              this.customerNumber,
              cartId
            );
          })
        )
        .subscribe((response: any) => {
          // CXE-877 show pickup first item no 11
          this.deliveryModeOptions =
            response?.deliveryModes[0]?.code === "pickUp"
              ? response?.deliveryModes
              : (response?.deliveryModes || []).slice().reverse();
          this.cdr.detectChanges();
        })
    );

    this.entries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length >= 0));
  }

  isSelectedOption(cart, modeValue) {
    if (cart?.deliveryMode?.code === modeValue?.code) {
      return true;
    }
    return false;
  }

  deliveryModeSelection(deliveryMode, i) {
    this.commonService.setInlineSpinner("deliveryPickup-loader");
    if (deliveryMode) {
      localStorage.removeItem("deliveryCompletedSteps");
      localStorage.removeItem("pickUpCompletedSteps");
      this.selectedOption = i;
      const queryParams = { deliveryModeId: deliveryMode };
      this.subscription.add(
        this.knBrCheckoutService
          .setDeliveryMode(this.customerNumber, queryParams) 
          .subscribe((resp) => {
            this.activeCartService.reloadActiveCart();

            // Wait for the updated cart
            this.subscription.add(
              this.getFreshCartOnce().subscribe((updatedCart) => {
                this.getPlantIdAndCallUpdatePlantIdMethod(
                  updatedCart?.deliveryAddress?.postalCode
                );
                this.commonService.setInlineSpinner("");
              })
            );
          })
      );
    }
  }

  getPlantIdAndCallUpdatePlantIdMethod(zipCode: any) {
    this.subscription.add(
      this.knBrCheckoutService.isValidZipCode(zipCode).subscribe((res: any) => {
        if (res && res?.carlisleFacilityZips?.length) {
          const plantName = res.carlisleFacilityZips[0]?.warehouses?.codes;
          const plantId = this.plantIdList.find((plant) => plant.name === plantName.toString())?.code || "";
          this.updatePlantIdToCart(plantId);
        } else {
          this.updatePlantIdToCart("");
        }
      })
    );
  }

  updatePlantIdToCart(plantId: any) {
    this.commonService.isCartLoading.set(true);
    const queryParams = { plantId: plantId ? plantId : "" };
    this.subscription.add(
      this.knBrCheckoutService
        .updatePlantIdToCart(queryParams)
        .subscribe((plantapiResp) => {
          this.activeCartService.reloadActiveCart();
        })
    );
  }

  getFreshCartOnce() {
    return this.activeCartService.getActive().pipe(
      filter((cart) => !!cart), // ignore null
      skip(1),
      take(1)
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
